export default "__VITE_ASSET__DY8iGN7c__"